export const openBackgroundImageUploader = (editorInstance, setStepContentState) => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*";

    // File upload handling
    fileInput.onchange = (event) => {
        const file = event.target.files[0];
        if (file) {
            // set state for desciption image file
            setStepContentState(prevState => ({ ...prevState, descriptionBgImgFile: file }))


            const reader = new FileReader();

            reader.onload = (e) => {
                const dataURL = e.target.result;

                // Set the selected image as the editor's background
                editorInstance.editor.style.backgroundImage = `url(${dataURL})`;
                editorInstance.editor.style.backgroundSize = "cover"; // Adjust to fit the container
                editorInstance.editor.style.backgroundRepeat = "no-repeat";
            };

            reader.readAsDataURL(file); // Read the file as a data URL
        }
    };

    // Trigger file input dialog
    fileInput.click();
};
